var configuratorStarted = false
var shopifyConfiguratorInterval = setInterval(function () {
  if ($) {
    clearInterval(shopifyConfiguratorInterval)

    if (configuratorStarted) {
      return
    }

    var hasProduct = false
    /* if( location.pathname === '/products/silvernova' ) {
            hasProduct = true;
        }
        else if( location.pathname === '/products/supernova' ) {
            hasProduct = true;
        }
        else if( location.pathname === '/products/duonova' ) {
            hasProduct = true;
        }
        else if( location.pathname === '/products/caja-especial-supernova' ) {
            hasProduct = true;
        }
        else if( location.pathname === '/cart' ) {
            hasProduct = true;
        } */

    if (!hasProduct) {
      return
    }

    $(document).ready(function () {
      configuratorStarted = true

      var config = {}

      config['silvernova'] = {
        product: '7525476204701',
        locale: 'es-ES',
        variantButtonSelector: { title: 'Diseño de certificado', key: '_design' },
        formElements: [
          //Elemente:
          {
            element: 'name',
            key: 'Nombre de la estrella',
            title: 'Nombre de la estrella',
            charactersLeftText: 'Caracteres restantes',
            maxCharacters: 25,
            isMandatory: true,
            isDigital: true,
            enableNextAfterInput: true
          },
          {
            element: 'date_picker',
            key: 'Fecha de registro',
            title: 'Fecha de registro',
            isDigital: true,
            subTitle:
              'Independientemente de la fecha que elija, su pedido se enviará inmediatamente. La fecha puede estar en el futuro o en el pasado.',
            isMandatory: true,
            placeholderText: '',
            isShowFormatButtons: false
          },
          {
            element: 'product_image_select',
            title: 'Luminosidad de la estrella',
            isMandatory: true,
            isDigital: true,
            isShowUpsell: true,
            upsellCheck: 'by-price',
            upsellProduct: '7525476040861',
            upsellTeaserText: 'Estrella más luminosa - ¡Ahora 50% de descuento!',
            upsellSubmitText: 'Continuar con la estrella más luminosa',
            upsellCancelText: 'No, no quiero una estrella más luminosa',
            subTitle:
              'Las estrellas luminosas, y sobre todo las muy luminosas, se encuentran mejor en el cielo.',
            product: '7525475844253',
            variants: [
              {
                number: '42748893036701',
                upsellNumber: '42748893429917',
                image:
                  'https://cdn.shopify.com/s/files/1/0619/5743/9645/files/brightness_normal.webp?v=1662987042',
                isActive: false
              },
              {
                number: '42748893069469',
                upsellNumber: '42748893462685',
                upsellNumber2: '46774722298190',
                image:
                  'https://cdn.shopify.com/s/files/1/0619/5743/9645/files/brightness_bright.webp?v=1662987042',
                upsellProduct: '8424991490382',
                upsellCheck: 'by-existence'
              },
              {
                number: '42748893102237',
                upsellNumber: '42748893495453',
                image:
                  'https://cdn.shopify.com/s/files/1/0619/5743/9645/files/brightness_very_bright.jpg?v=1662987044'
              }
            ]
          },
          {
            element: 'delivery_button_selector',
            isDigital: true,
            title: 'Opciones del paquete',
            subTitle: '',
            isMandatory: true,
            product: 7525476073629,
            variants: [
              {
                number: '42748893724829',
                iconOverwrite:
                  'https://cdn.shopify.com/s/files/1/0619/5743/9645/files/delivery_mail.webp?v=1662991797',
                isOnlyDigital: true,
                isShowPrice: true,
                subTitle:
                  'No se enviará ningún artículo físico. Los documentos de regalo de estrella (certificado y tarjeta de búsqueda de estrella) se enviarán por correo electrónico en un plazo de 20 minutos. No se le enviarán copias impresas de los documentos. Registramos su estrella y le enviamos por correo electrónico el certificado y la tarjeta de búsqueda de estrellas en formato PDF.'
              },
              {
                number: '42748893790365',
                iconOverwrite:
                  'https://cdn.shopify.com/s/files/1/0619/5743/9645/files/delivery_box.webp?v=1662991797',
                isShowPrice: true,
                subTitle:
                  'Además del paquete BÁSICO, recibirás nuestro set de regalo físico con: Carpeta de presentación, certificado, carta estelar con carta de confirmación, XXL cartel estrella, tarjeta de felicitación, folleto informativo sobre el universo, guía para encontrar su estrella y mucho más. Todo le será enviado por DHL o FedEx.'
              }
            ]
          },
          {
            element: 'email',
            key: 'Email',
            title: 'Correo electrónico para el envío digital',
            subTitle:
              'Ingrese la dirección de correo electrónico a la cual podemos enviar los documentos digitales.',
            maxCharacters: 100,
            isMandatory: false,
            isDigital: true,
            enableNextAfterInput: true,
            url: 'https://api.space-registry.org/api/v1/tracking/shopify/customers',
            domain: 'www.registro-galaxia.es'
          },
          {
            element: 'text',
            key: 'Add a Greeting Card',
            product: '7525474926749',
            title: 'Añadir tarjeta de felicitación',
            charactersLeftText: 'Caracteres restantes',
            maxCharacters: 150,
            isMandatory: false
          },
          {
            element: 'product_choose',
            hideIfNoText: true,
            title: 'Revisión del texto',
            buttonTextYes: 'Sí',
            buttonTextNo: 'No',
            product: '7525475090589',
            isMandatory: false
          },
          {
            element: 'product_image_select',
            title: 'Añadir un marco de fotos',
            canDeselect: false,
            product: '7525475352733',
            isShowUpsell: false,
            upsellCheck: 'by-quantity',
            upsellProduct: '7525475549341',
            variants: [
              {
                number: '42748892053661',
                upsellNumber: '42748892283037',
                canChangeQuantity: true,
                image:
                  'https://cdn.shopify.com/s/files/1/0619/5743/9645/files/frame_black.webp?v=1662988842',
                isActive: false
              },
              {
                number: '42748892086429',
                upsellNumber: '42748892315805',
                canChangeQuantity: true,
                image:
                  'https://cdn.shopify.com/s/files/1/0619/5743/9645/files/frame_white.webp?v=1662988842'
              },
              {
                number: '42748892119197',
                upsellNumber: '42748892348573',
                canChangeQuantity: true,
                image:
                  'https://cdn.shopify.com/s/files/1/0619/5743/9645/files/frame_alu.webp?v=1662988842'
              }
            ]
          },
          {
            element: 'product_additional',
            key: '_product_additional',
            title: 'Añadir copias adicionales',
            subTitle:
              'Adicional: Carpeta, certificado, carta de confirmación, XXL cartel estrella, tarjeta de felicitación, folleto galaxia, guía para encontrar su estrella',
            product: '7525475188893',
            maxQuantity: 50,
            canChangeCartQuantity: true
          },
          {
            element: 'image_select_slider',
            title: 'Añadir una colgante de oro del zodiaco',
            subTitle:
              'Colgante del zodiaco chapado en oro (100% resistente al agua y a las alergias)',
            tooltipText: '',
            isMandatory: false,
            selectText: 'Seleccionar',
            deselectText: 'No añada ningún',
            canDeselect: true,
            showImages: true,
            product: '7525476171933',
            hasNoBorder: true,
            isCompact: true
          },
          {
            element: 'image_select_slider',
            title: 'Añadir un collar con signo zodiacal y grabado',
            subTitle:
              'Collar de signo zodiacal con grabado (el nombre de tu estrella, la fecha introducida y las coordenadas de la estrella)',
            tooltipText: '',
            isMandatory: false,
            selectText: 'Seleccionar',
            deselectText: 'No añada ningún',
            canDeselect: true,
            showImages: true,
            product: '8631349182798',
            hasNoBorder: true,
            isCompact: true
          }
        ],

        giftProducts: [
          { product: '7525476401309' }
          //Beispiel { product:'7352744313056' }
          //Beispiel, Produkt mit mehreren Varianten, bestimmte Variante als Geschenk auswählen: { product:'7352744313056', number:'42545842749664' }
        ]
      }

      config['supernova'] = {
        product: '7525476368541',
        locale: 'es-ES',
        variantButtonSelector: { title: 'Diseño de certificado', key: '_design' },
        formElements: [
          //Elemente:
          {
            element: 'name',
            key: 'Nombre de la estrella',
            title: 'Nombre de la estrella',
            charactersLeftText: 'Caracteres restantes',
            isDigital: true,
            maxCharacters: 25,
            isMandatory: true,
            enableNextAfterInput: true
          },
          {
            element: 'date_picker',
            key: 'Fecha de registro',
            title: 'Fecha de registro',
            subTitle:
              'Independientemente de la fecha que elija, su pedido se enviará inmediatamente. La fecha puede estar en el futuro o en el pasado.',
            isMandatory: true,
            isDigital: true,
            placeholderText: '',
            isShowFormatButtons: false
          },
          {
            element: 'select',
            key: 'Constelación',
            title: 'Constelación',
            subTitle: 'Elige la constelación en la que quieres que esté tu estrella.',
            isDigital: true,
            isMandatory: true,
            selectText: 'Seleccionar',
            items: [
              {
                icon: 'widder',
                text: 'ARIES (Marzo 21 - Abril 19)',
                value: 'ARIES (Mar 21 - Apr 19)'
              },
              {
                icon: 'stier',
                text: 'TAURO (Abril 20 - Mayo 20)',
                value: 'TAURUS (Apr 20 - May 20)'
              },
              {
                icon: 'gemini',
                text: 'GÉMINIS (Mayo 21 - Junio 20)',
                value: 'GEMINI (May 21 - Jun 20)'
              },
              {
                icon: 'cancer',
                text: 'CÁNCER (Junio 21 - Julio 22)',
                value: 'CANCER (Jun 21 - Jul 22)'
              },
              { icon: 'leo', text: 'LEO (Julio 23 - Agosto 22)', value: 'LEO (Jul 23 - Aug 22)' },
              {
                icon: 'virgo',
                text: 'VIRGO (Agosto 23 - Septiembre 22)',
                value: 'VIRGO (Aug 23 - Sep 22)'
              },
              {
                icon: 'libra',
                text: 'LIBRA (Septiembre 23 - Octubre 22)',
                value: 'LIBRA (Sep 23 - Oct 22)'
              },
              {
                icon: 'scorpio',
                text: 'ESCORPIO (Octubre 23 - Noviembre 21)',
                value: 'SCORPIO (Oct 23 - Nov 21)'
              },
              {
                icon: 'sagittarius',
                text: 'SAGITARIO (Noviembre 22 - Diciembre 21)',
                value: 'SAGITTARIUS (Nov 22 - Dec 21)'
              },
              {
                icon: 'capricorn',
                text: 'CAPRICORNIO (Diciembre 22 - Enero 19)',
                value: 'CAPRICORN (Dec 22 - Jan 19)'
              },
              {
                icon: 'aquarius',
                text: 'ACUARIO (Enero 20 - Febrero 18)',
                value: 'AQUARIUS (Jan 20 - Feb 18)'
              },
              {
                icon: 'pisces',
                text: 'PISCIS (Febrero 19 - Mayo 20)',
                value: 'PISCES (Feb 19 - Mar 20)'
              },
              { icon: '', text: 'ORIÓN', value: 'ORION' },
              { icon: '', text: 'CARRO MAYOR', value: 'THE BIG DIPPER / URSA MAJOR' },
              { icon: '', text: 'CARRO MENOR', value: 'THE LITTLE DIPPER / URSA MINOR' }
            ]
          },
          {
            element: 'product_image_select',
            title: 'Luminosidad de la estrella',
            isMandatory: true,
            isDigital: true,
            isShowUpsell: true,
            upsellCheck: 'by-price',
            upsellProduct: '7525476040861',
            upsellTeaserText: 'Estrella más luminosa - ¡Ahora 50% de descuento!',
            upsellSubmitText: 'Continuar con la estrella más luminosa',
            upsellCancelText: 'No, no quiero una estrella más luminosa',
            subTitle:
              'Las estrellas luminosas, y sobre todo las muy luminosas, se encuentran mejor en el cielo.',
            product: '7525475844253',
            variants: [
              {
                number: '42748893036701',
                upsellNumber: '42748893429917',
                image:
                  'https://cdn.shopify.com/s/files/1/0619/5743/9645/files/brightness_normal.webp?v=1662987042',
                isActive: false
              },
              {
                number: '42748893069469',
                upsellNumber: '42748893462685',
                upsellNumber2: '46774722298190',
                image:
                  'https://cdn.shopify.com/s/files/1/0619/5743/9645/files/brightness_bright.webp?v=1662987042',
                upsellProduct: '8424991490382',
                upsellCheck: 'by-existence'
              },
              {
                number: '42748893102237',
                upsellNumber: '42748893495453',
                image:
                  'https://cdn.shopify.com/s/files/1/0619/5743/9645/files/brightness_very_bright.jpg?v=1662987044'
              }
            ]
          },
          {
            element: 'delivery_button_selector',
            isDigital: true,
            title: 'Opciones del paquete',
            subTitle: '',
            isMandatory: true,
            product: 7525476073629,
            variants: [
              {
                number: '42748893724829',
                iconOverwrite:
                  'https://cdn.shopify.com/s/files/1/0619/5743/9645/files/delivery_mail.webp?v=1662991797',
                isOnlyDigital: true,
                isShowPrice: true,
                subTitle:
                  'No se enviará ningún artículo físico. Los documentos de regalo de estrella (certificado y tarjeta de búsqueda de estrella) se enviarán por correo electrónico en un plazo de 20 minutos. No se le enviarán copias impresas de los documentos. Registramos su estrella y le enviamos por correo electrónico el certificado y la tarjeta de búsqueda de estrellas en formato PDF.'
              },
              {
                number: '42748893790365',
                iconOverwrite:
                  'https://cdn.shopify.com/s/files/1/0619/5743/9645/files/delivery_box.webp?v=1662991797',
                isShowPrice: true,
                subTitle:
                  'Además del paquete BÁSICO, recibirás nuestro set de regalo físico con: Carpeta de presentación, certificado, carta estelar con carta de confirmación, XXL cartel estrella, tarjeta de felicitación, folleto informativo sobre el universo, guía para encontrar su estrella y mucho más. Todo le será enviado por DHL o FedEx.'
              }
            ]
          },
          {
            element: 'email',
            key: 'Email',
            title: 'Correo electrónico para el envío digital',
            subTitle:
              'Ingrese la dirección de correo electrónico a la cual podemos enviar los documentos digitales.',
            maxCharacters: 100,
            isMandatory: false,
            isDigital: true,
            enableNextAfterInput: true,
            url: 'https://api.space-registry.org/api/v1/tracking/shopify/customers',
            domain: 'www.registro-galaxia.es'
          },
          {
            element: 'text',
            key: 'Add a Greeting Card',
            product: '7525474926749',
            title: 'Añadir tarjeta de felicitación',
            charactersLeftText: 'Caracteres restantes',
            maxCharacters: 150,
            isMandatory: false
          },
          {
            element: 'product_choose',
            hideIfNoText: true,
            title: 'Revisión del texto',
            buttonTextYes: 'Sí',
            buttonTextNo: 'No',
            product: '7525475090589',
            isMandatory: false
          },
          {
            element: 'product_image_select',
            title: 'Añadir un marco de fotos',
            canDeselect: false,
            product: '7525475352733',
            isShowUpsell: false,
            upsellCheck: 'by-quantity',
            upsellProduct: '7525475549341',
            variants: [
              {
                number: '42748892053661',
                upsellNumber: '42748892283037',
                canChangeQuantity: true,
                image:
                  'https://cdn.shopify.com/s/files/1/0619/5743/9645/files/frame_black.webp?v=1662988842',
                isActive: false
              },
              {
                number: '42748892086429',
                upsellNumber: '42748892315805',
                canChangeQuantity: true,
                image:
                  'https://cdn.shopify.com/s/files/1/0619/5743/9645/files/frame_white.webp?v=1662988842'
              },
              {
                number: '42748892119197',
                upsellNumber: '42748892348573',
                canChangeQuantity: true,
                image:
                  'https://cdn.shopify.com/s/files/1/0619/5743/9645/files/frame_alu.webp?v=1662988842'
              }
            ]
          },
          {
            element: 'product_additional',
            key: '_product_additional',
            title: 'Añadir copias adicionales',
            subTitle:
              'Adicional: Carpeta, certificado, carta de confirmación, XXL cartel estrella, tarjeta de felicitación, folleto galaxia, guía para encontrar su estrella',
            product: '7525475188893',
            maxQuantity: 50,
            canChangeCartQuantity: true
          },
          {
            element: 'image_select_slider',
            title: 'Añadir una colgante de oro del zodiaco',
            subTitle:
              'Colgante del zodiaco chapado en oro (100% resistente al agua y a las alergias)',
            tooltipText: '',
            isMandatory: false,
            selectText: 'Seleccionar',
            deselectText: 'No añada ningún',
            canDeselect: true,
            showImages: true,
            product: '7525476171933',
            hasNoBorder: true,
            isCompact: true
          },
          {
            element: 'image_select_slider',
            title: 'Añadir un collar con signo zodiacal y grabado',
            subTitle:
              'Collar de signo zodiacal con grabado (el nombre de tu estrella, la fecha introducida y las coordenadas de la estrella)',
            tooltipText: '',
            isMandatory: false,
            selectText: 'Seleccionar',
            deselectText: 'No añada ningún',
            canDeselect: true,
            showImages: true,
            product: '8631349182798',
            hasNoBorder: true,
            isCompact: true
          }
        ],
        giftProducts: [
          { product: '7525476401309' }
          //Beispiel { product:'7352744313056' }
          //Beispiel, Produkt mit mehreren Varianten, bestimmte Variante als Geschenk auswählen: { product:'7352744313056', number:'42545842749664' }
        ]
      }

      config['caja-especial-supernova'] = {
        product: '8613491343694',
        locale: 'es-ES',
        variantButtonSelector: { title: 'Diseño de certificado', key: '_design' },
        formElements: [
          //Elemente:
          {
            element: 'name',
            key: 'Nombre de la estrella',
            title: 'Nombre de la estrella',
            charactersLeftText: 'Caracteres restantes',
            isDigital: true,
            maxCharacters: 25,
            isMandatory: true,
            enableNextAfterInput: true
          },
          {
            element: 'date_picker',
            key: 'Fecha de registro',
            title: 'Fecha de registro',
            subTitle:
              'Independientemente de la fecha que elija, su pedido se enviará inmediatamente. La fecha puede estar en el futuro o en el pasado.',
            isMandatory: true,
            isDigital: true,
            placeholderText: '',
            isShowFormatButtons: false
          },
          {
            element: 'select',
            key: 'Constelación',
            title: 'Constelación',
            subTitle: 'Elige la constelación en la que quieres que esté tu estrella.',
            isDigital: true,
            isMandatory: true,
            selectText: 'Seleccionar',
            items: [
              {
                icon: 'widder',
                text: 'ARIES (Marzo 21 - Abril 19)',
                value: 'ARIES (Mar 21 - Apr 19)'
              },
              {
                icon: 'stier',
                text: 'TAURO (Abril 20 - Mayo 20)',
                value: 'TAURUS (Apr 20 - May 20)'
              },
              {
                icon: 'gemini',
                text: 'GÉMINIS (Mayo 21 - Junio 20)',
                value: 'GEMINI (May 21 - Jun 20)'
              },
              {
                icon: 'cancer',
                text: 'CÁNCER (Junio 21 - Julio 22)',
                value: 'CANCER (Jun 21 - Jul 22)'
              },
              { icon: 'leo', text: 'LEO (Julio 23 - Agosto 22)', value: 'LEO (Jul 23 - Aug 22)' },
              {
                icon: 'virgo',
                text: 'VIRGO (Agosto 23 - Septiembre 22)',
                value: 'VIRGO (Aug 23 - Sep 22)'
              },
              {
                icon: 'libra',
                text: 'LIBRA (Septiembre 23 - Octubre 22)',
                value: 'LIBRA (Sep 23 - Oct 22)'
              },
              {
                icon: 'scorpio',
                text: 'ESCORPIO (Octubre 23 - Noviembre 21)',
                value: 'SCORPIO (Oct 23 - Nov 21)'
              },
              {
                icon: 'sagittarius',
                text: 'SAGITARIO (Noviembre 22 - Diciembre 21)',
                value: 'SAGITTARIUS (Nov 22 - Dec 21)'
              },
              {
                icon: 'capricorn',
                text: 'CAPRICORNIO (Diciembre 22 - Enero 19)',
                value: 'CAPRICORN (Dec 22 - Jan 19)'
              },
              {
                icon: 'aquarius',
                text: 'ACUARIO (Enero 20 - Febrero 18)',
                value: 'AQUARIUS (Jan 20 - Feb 18)'
              },
              {
                icon: 'pisces',
                text: 'PISCIS (Febrero 19 - Mayo 20)',
                value: 'PISCES (Feb 19 - Mar 20)'
              },
              { icon: '', text: 'ORIÓN', value: 'ORION' },
              { icon: '', text: 'CARRO MAYOR', value: 'THE BIG DIPPER / URSA MAJOR' },
              { icon: '', text: 'CARRO MENOR', value: 'THE LITTLE DIPPER / URSA MINOR' }
            ]
          },
          {
            element: 'product_image_select',
            title: 'Luminosidad de la estrella',
            isMandatory: true,
            isDigital: true,
            isShowUpsell: false,
            upsellCheck: 'by-price',
            upsellProduct: '7525476040861',
            upsellTeaserText: 'Estrella más luminosa - ¡Ahora 50% de descuento!',
            upsellSubmitText: 'Continuar con la estrella más luminosa',
            upsellCancelText: 'No, no quiero una estrella más luminosa',
            subTitle:
              'Se obtiene una estrella muy luminosa. Estas son más fáciles de encontrar en el cielo nocturno.',
            product: '8613443993934',
            variants: [
              {
                number: '47287755309390',
                upsellNumber: '42748893495453',
                image:
                  'https://cdn.shopify.com/s/files/1/0619/5743/9645/files/brightness_very_bright.jpg?v=1662987044'
              }
            ]
          },
          {
            element: 'text',
            key: 'Add a Greeting Card',
            product: '8613443436878',
            title: 'Tarjeta de felicitación',
            charactersLeftText: 'Caracteres restantes',
            maxCharacters: 150,
            isMandatory: false
          },
          //{element:'product_choose',hideIfNoText:true,title:'Revisión del texto',buttonTextYes:'Sí',buttonTextNo:'No', product:'7525475090589', isMandatory: false},
          {
            element: 'product_image_select',
            title: 'Marco de fotos',
            canDeselect: false,
            isMandatory: true,
            product: '8613441536334',
            isShowUpsell: false,
            upsellCheck: 'by-quantity',
            upsellProduct: '7525475549341',
            variants: [
              {
                number: '47287751016782',
                upsellNumber: '42748892283037',
                canChangeQuantity: false,
                image:
                  'https://cdn.shopify.com/s/files/1/0619/5743/9645/files/frame_black.webp?v=1662988842',
                isActive: false
              },
              {
                number: '47287751049550',
                upsellNumber: '42748892315805',
                canChangeQuantity: false,
                image:
                  'https://cdn.shopify.com/s/files/1/0619/5743/9645/files/frame_white.webp?v=1662988842'
              }
              //{number:'42748892119197',upsellNumber:'42748892348573',canChangeQuantity:true,image:'https://cdn.shopify.com/s/files/1/0619/5743/9645/files/frame_alu.webp?v=1662988842'}
            ]
          },
          //{element:'product_additional',key:'_product_additional',title:'Añadir copias adicionales',subTitle:'Adicional: Carpeta, certificado, carta de confirmación, XXL cartel estrella, tarjeta de felicitación, folleto galaxia, guía para encontrar su estrella',product:'7525475188893',maxQuantity:50, canChangeCartQuantity:true},
          {
            element: 'image_select_slider',
            title: 'Collar con signo zodiacal y grabado',
            subTitle:
              'Collar de signo zodiacal con grabado (el nombre de tu estrella, la fecha introducida y las coordenadas de la estrella)',
            tooltipText: '',
            isMandatory: true,
            selectText: 'Seleccionar',
            deselectText: 'No añada ningún',
            canDeselect: true,
            showImages: true,
            isMaxOne: true,
            product: '8613441208654',
            hasNoBorder: true,
            isCompact: true
          }
          //{element:'image_select_slider',title:'',subTitle:'',tooltipText:"",isMandatory: false,selectText:'Seleccionar',deselectText:'No añada ningún', canDeselect:true, showImages:true,product:'7525476171933',hasNoBorder:true,isCompact:true}
        ],
        giftProducts: [
          { product: '7525476401309' }
          //Beispiel { product:'7352744313056' }
          //Beispiel, Produkt mit mehreren Varianten, bestimmte Variante als Geschenk auswählen: { product:'7352744313056', number:'42545842749664' }
        ]
      }

      config['duonova'] = {
        product: '7525476303005',
        changeNamesAfterVariantSwitch: true,
        variantButtonSelector: { title: 'Diseño de certificado', key: '_design' },
        locale: 'es-ES',
        formElements: [
          {
            element: 'name',
            key: 'Nombre de la primera estrella',
            title: 'Nombre de la primera estrella',
            subTitle: '',
            isDigital: true,
            charactersLeftText: 'Caracteres restantes',
            maxCharacters: 25,
            isMandatory: true,
            enableNextAfterInput: true
          },
          {
            element: 'name',
            key: 'Nombre de la segunda estrella',
            title: 'Nombre de la segunda estrella',
            subTitle: '',
            isDigital: true,
            charactersLeftText: 'Caracteres restantes',
            maxCharacters: 25,
            isMandatory: true,
            enableNextAfterInput: true
          },
          {
            element: 'date_picker',
            key: 'Fecha de registro',
            title: 'Fecha de registro',
            isDigital: true,
            subTitle:
              'Independientemente de la fecha que elija, su pedido se enviará inmediatamente. La fecha puede estar en el futuro o en el pasado.',
            isMandatory: true,
            placeholderText: '',
            isShowFormatButtons: false
          },
          {
            element: 'product_image_select',
            title: 'Luminosidad de la estrella',
            isMandatory: true,
            isDigital: true,
            isShowUpsell: true,
            upsellCheck: 'by-price',
            upsellProduct: '7525476040861',
            upsellTeaserText: 'Estrella más luminosa - ¡Ahora 50% de descuento!',
            upsellSubmitText: 'Continuar con la estrella más luminosa',
            upsellCancelText: 'No, no quiero una estrella más luminosa',
            subTitle:
              'Las estrellas luminosas, y sobre todo las muy luminosas, se encuentran mejor en el cielo.',
            product: '7525475844253',
            variants: [
              {
                number: '42748893036701',
                upsellNumber: '42748893429917',
                image:
                  'https://cdn.shopify.com/s/files/1/0619/5743/9645/files/brightness_normal.webp?v=1662987042',
                isActive: false
              },
              {
                number: '42748893069469',
                upsellNumber: '42748893462685',
                upsellNumber2: '46774722298190',
                image:
                  'https://cdn.shopify.com/s/files/1/0619/5743/9645/files/brightness_bright.webp?v=1662987042',
                upsellProduct: '8424991490382',
                upsellCheck: 'by-existence'
              },
              {
                number: '42748893102237',
                upsellNumber: '42748893495453',
                image:
                  'https://cdn.shopify.com/s/files/1/0619/5743/9645/files/brightness_very_bright.jpg?v=1662987044'
              }
            ]
          },
          {
            element: 'delivery_button_selector',
            isDigital: true,
            title: 'Opciones del paquete',
            subTitle: '',
            isMandatory: true,
            product: 7525476073629,
            variants: [
              {
                number: '42748893724829',
                iconOverwrite:
                  'https://cdn.shopify.com/s/files/1/0619/5743/9645/files/delivery_mail.webp?v=1662991797',
                isOnlyDigital: true,
                isShowPrice: true,
                subTitle:
                  'No se enviará ningún artículo físico. Los documentos de regalo de estrella (certificado y tarjeta de búsqueda de estrella) se enviarán por correo electrónico en un plazo de 20 minutos. No se le enviarán copias impresas de los documentos. Registramos su estrella y le enviamos por correo electrónico el certificado y la tarjeta de búsqueda de estrellas en formato PDF.'
              },
              {
                number: '42748893790365',
                iconOverwrite:
                  'https://cdn.shopify.com/s/files/1/0619/5743/9645/files/delivery_box.webp?v=1662991797',
                isShowPrice: true,
                subTitle:
                  'Además del paquete BÁSICO, recibirás nuestro set de regalo físico con: Carpeta de presentación, certificado, carta estelar con carta de confirmación, XXL cartel estrella, tarjeta de felicitación, folleto informativo sobre el universo, guía para encontrar su estrella y mucho más. Todo le será enviado por DHL o FedEx.'
              }
            ]
          },
          {
            element: 'email',
            key: 'Email',
            title: 'Correo electrónico para el envío digital',
            subTitle:
              'Ingrese la dirección de correo electrónico a la cual podemos enviar los documentos digitales.',
            maxCharacters: 100,
            isMandatory: false,
            isDigital: true,
            enableNextAfterInput: true,
            url: 'https://api.space-registry.org/api/v1/tracking/shopify/customers',
            domain: 'www.registro-galaxia.es'
          },
          {
            element: 'text',
            key: 'Add a Greeting Card',
            product: '7525474926749',
            title: 'Añadir tarjeta de felicitación',
            charactersLeftText: 'Caracteres restantes',
            maxCharacters: 150,
            isMandatory: false
          },
          {
            element: 'product_choose',
            hideIfNoText: true,
            title: 'Revisión del texto',
            buttonTextYes: 'Sí',
            buttonTextNo: 'No',
            product: '7525475090589',
            isMandatory: false
          },
          {
            element: 'product_image_select',
            title: 'Añadir dos marco de fotos',
            subTitle: 'El precio incluye los marcos de los dos certificados',
            canDeselect: false,
            product: '7525475614877',
            isShowUpsell: false,
            upsellCheck: 'by-quantity',
            upsellProduct: '7525475713181',
            variants: [
              {
                number: '42748892414109',
                upsellNumber: '42748892577949',
                canChangeQuantity: true,
                image:
                  'https://cdn.shopify.com/s/files/1/0619/5743/9645/files/Product_icons_star_naming_38.webp?v=1662990950',
                isActive: false
              },
              {
                number: '42748892446877',
                upsellNumber: '42748892610717',
                canChangeQuantity: true,
                image:
                  'https://cdn.shopify.com/s/files/1/0619/5743/9645/files/Product_icons_star_naming_37.webp?v=1662990950'
              },
              {
                number: '42748892479645',
                upsellNumber: '42748892643485',
                canChangeQuantity: true,
                image:
                  'https://cdn.shopify.com/s/files/1/0619/5743/9645/files/Product_icons_star_naming_36.webp?v=1662990950'
              }
            ]
          },
          {
            element: 'product_additional',
            key: '_product_additional',
            title: 'Añadir copias adicionales',
            subTitle:
              'Adicional: Carpeta, certificado, carta de confirmación, XXL cartel estrella, tarjeta de felicitación, folleto galaxia, guía para encontrar su estrella',
            tooltipText: '',
            product: '7525475188893',
            maxQuantity: 50,
            canChangeCartQuantity: true
          },
          {
            element: 'image_select_slider',
            title: 'Añadir una colgante de oro del zodiaco',
            subTitle:
              'Colgante del zodiaco chapado en oro (100% resistente al agua y a las alergias)',
            isMandatory: false,
            selectText: 'Seleccionar',
            deselectText: 'No añada ningún',
            canDeselect: true,
            showImages: true,
            product: '7525476171933',
            hasNoBorder: true,
            isCompact: true
          },
          {
            element: 'image_select_slider',
            title: 'Añadir un collar con signo zodiacal y grabado',
            subTitle:
              'Collar de signo zodiacal con grabado (el nombre de tu estrella, la fecha introducida y las coordenadas de la estrella)',
            tooltipText: '',
            isMandatory: false,
            selectText: 'Seleccionar',
            deselectText: 'No añada ningún',
            canDeselect: true,
            showImages: true,
            product: '8631349182798',
            hasNoBorder: true,
            isCompact: true
          }
        ],
        giftProducts: [
          { product: '7525476401309' }
          //Beispiel { product:'7352744313056' }
          //Beispiel, Produkt mit mehreren Varianten, bestimmte Variante als Geschenk auswählen: { product:'7352744313056', number:'42545842749664' }
        ]
      }

      var selectedConfig = []

      /* if (location.pathname.indexOf('/products/silvernova') !== -1) {
        selectedConfig = config['silvernova']
      } else if (location.pathname.indexOf('/products/supernova') !== -1) {
        selectedConfig = config['supernova']
      } else if (location.pathname.indexOf('/products/duonova') !== -1) {
        selectedConfig = config['duonova']
      } else if (location.pathname === '/products/caja-especial-supernova') {
        selectedConfig = config['caja-especial-supernova']
      } else {
        selectedConfig = config['silvernova']
      } */

      selectedConfig['translations'] = {
        'app.formelements.change.text': 'Cambia',
        'app.formelements.additional.qty': 'Cantidad',
        'app.formelements.imageselectbutton.noextracharge': 'Sin costes adicionales',

        'app.basket.basket-group.title': 'Tu elección',
        'app.basket.basket-group.remove-button-text': 'Borra',

        'app.basket.upsell-overlay.intro-title': 'Nombre de la estrella',
        'app.basket.upsell-overlay.stoerer': '¡HOY 50% DE DESCUENTO!',
        'app.basket.upsell-overlay.btn-yes-text': 'Continuar con el marco de fotos',
        'app.basket.upsell-overlay.btn-no-text': 'Quiero mi certificado sin marco de fotos'
      }

      selectedConfig['isUseCurrency'] = true

      var currencySymbol = $('.currency-symbol').data('currency-symbol')

      if (currencySymbol) {
        if (currencySymbol == '₹') {
          currencySymbol = 'Rs. '
        }

        selectedConfig['currencySymbol'] = currencySymbol
      }

      //Preis entfernen:
      //$('#ProductPrice').attr('id', ' ');
      //$('#ProductPrice').attr('orig-price', '');

      //
      var $mwProductOptions = $('.mw-product-options')
      $('<div class="configurator-app-container en-version"></div>').insertAfter(
        $('[id^="ProductSelect-"]')
      )
      $mwProductOptions.remove()

      //Additional Submit Button
      $('.product-form__controls-group.product-form__controls-group--submit').remove()

      //AddToCart Button
      var $AddToCartButtonNew = $(
        '<button type="submit" name="add" aria-label="Add to cart" class="btn product-form__cart-submit configurator-submit-button" data-add-to-cart="">\n' +
          '                  <span data-add-to-cart-text="">\n' +
          '                    \n' +
          '                      Add to cart\n' +
          '                    \n' +
          '                  </span>\n' +
          '                  <span class="hide" data-loader="">\n' +
          '                    <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-spinner" viewBox="0 0 20 20"><path d="M7.229 1.173a9.25 9.25 0 1 0 11.655 11.412 1.25 1.25 0 1 0-2.4-.698 6.75 6.75 0 1 1-8.506-8.329 1.25 1.25 0 1 0-.75-2.385z" fill="#919EAB"></path></svg>\n' +
          '                  </span>\n' +
          '                </button>'
      )

      //$('.product-form__item--submit').prepend($AddToCartButtonNew);

      $('form.product-form').after($AddToCartButtonNew)
      //$AddToCartButtonClone.attr('id', '');
      //$AddToCartButtonClone.prop('disabled', false)
      //$AddToCartButtonClone.addClass('configurator-submit-button');
      //$AddToCartButtonClone.prop('data-add-to-cart',false);
      //$AddToCartButtonClone.insertAfter( $('#AddToCart') );

      //Submit Button Bereich anzeigen:
      setInterval(function () {
        $('.product-form__controls-group--submit').show()

        //App Submit Button remove:
        $('#mwAddToCart').remove()
      }, 1000)

      var $sticky = $('<div class="rf-flagship-sticky"></div>')
      //
      $sticky.append($('.product-single__media-group').children())
      $('.product-single__media-group').append($sticky)

      //$AddToCartButton.css('display', 'block');
      //$AddToCartButton.css('visibility', 'visible');
      //$AddToCartButton.css('position', 'static');
      //$AddToCartButton.css('left', '0');

      //$('<div class="configurator-app-container"></div>');

      $('body').addClass('en-version')

      var shopifyConfigurator = new ShopifyConfiguratorController(
        $('.configurator-app-container'),
        selectedConfig,
        config
      )

      $('.galaxieregister-configurator').addClass('en-version')
    })
  }
}, 500)
